import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DiscoverCollection } from '@freelancer/datastore/collections';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-list-details',
  template: `
    <fl-icon
      [color]="IconColor.MID"
      [name]="collection.isPrivate ? 'ui-lock-closed' : 'ui-globe'"
      [size]="IconSize.SMALL"
    ></fl-icon>
    <fl-text
      [color]="FontColor.MID"
      [flMarginRight]="Margin.XXSMALL"
      [size]="TextSize.XXSMALL"
    >
      <ng-container
        *ngIf="collection.isPrivate"
        i18n="My List Private Collection Text"
      >
        Private
      </ng-container>
      <ng-container
        *ngIf="!collection.isPrivate"
        i18n="My List Public Collection Text"
      >
        Public
      </ng-container>
    </fl-text>
    <fl-text
      i18n="Text interpunct"
      [color]="FontColor.MID"
      [flMarginRight]="Margin.XXSMALL"
      [size]="TextSize.XSMALL"
      [weight]="FontWeight.BOLD"
    >
      ·
    </fl-text>
    <fl-text [color]="FontColor.MID" [size]="TextSize.XXSMALL">
      <ng-container
        *ngIf="collection.itemCount === 1"
        i18n="My List Page Single Member"
      >
        1 member
      </ng-container>
      <ng-container
        *ngIf="collection.itemCount !== 1"
        i18n="My List Page Count Of Members"
      >
        {{ collection.itemCount }} members
      </ng-container>
    </fl-text>
  `,
  styleUrls: ['./user-list-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserListDetailsComponent {
  FontColor = FontColor;
  FontWeight = FontWeight;
  IconColor = IconColor;
  IconSize = IconSize;
  Margin = Margin;
  TextSize = TextSize;

  @Input() collection: DiscoverCollection;
}
